// extracted by mini-css-extract-plugin
module.exports = {"className":"fa-AF_className__d3_g5"};